import React, { useRef } from 'react';

import {
  Stack,
  Link,
  Flex,
  Box,
  IconButton,
  Icon,
  icons,
  chakra as C,
  TapTheme,
} from '@tapresearch/ui/components';
import { useDisclosure } from '@tapresearch/ui/hooks';
import { MobileSidebar } from './MobileSidebar';
import { AccountMenu } from './AccountMenu';
import { ProductMenu } from './ProductMenu';
import { OrganizationalContextBanner } from './OrganizationalContextBanner';
import { useBreakpoint } from 'Shared/Hooks';
import { NewToTapBanner } from './NewToTapBanner';

export const SiteNav = ({
  currentProduct,
  asset,
  user,
  sidebar: Sidebar,
  sidebarProps,
  headerContent = null,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const triggerBtnRef = useRef();
  const { isSm } = useBreakpoint();

  const { is_active, role } = (user && user.organization_membership) || {};
  const { customer } = (user && user.organization) || {};
  const isBannedCustomer =
    customer &&
    customer.insights_moderation_status ===
      asset.constants.INSIGHTS_MODERATION_STATUS_BANNED;
  return (
    <>
      <Stack {...Styles.NavWrapper}>
        {isSm && user && (
          <Box w="80px">
            <IconButton
              icon={<Icon boxSize={7} icon={icons.ai.OutlineMenu} />}
              ref={triggerBtnRef}
              size="lg"
              onClick={onOpen}
              variant="ghost"
              color="black"
            />
            <MobileSidebar
              isOpen={isOpen}
              onOpen={onOpen}
              onClose={onClose}
              triggerBtnRef={triggerBtnRef}
            >
              <Sidebar isMobile={isSm} {...sidebarProps} />
            </MobileSidebar>
          </Box>
        )}

        <Flex
          justify={isSm ? 'center' : 'flex-start'}
          flexGrow={!headerContent ? 1 : 0}
          minW="160px"
        >
          <Link
            href={
              user
                ? `/organizations/${user.organization.identifier}/dashboard`
                : '/'
            }
          >
            <C.img h={isSm ? 10 : 12} src={asset.logo_dark} />
          </Link>
        </Flex>

        {!!headerContent && (
          <Flex minW="530px" flexGrow={1} pr={4}>{headerContent}</Flex>
        )}

        {user && (
          <Flex {...Styles.RightNav}>
            {is_active && !isBannedCustomer && (
              <ProductMenu
                currentProduct={currentProduct}
                isMobile={isSm}
                asset={asset}
                user={user}
              />
            )}

            {user && <AccountMenu user={user} asset={asset} />}
          </Flex>
        )}
      </Stack>
      {user &&
        user.is_ops &&
        role === asset.constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS && (
          <OrganizationalContextBanner
            organizationName={user.organization.company_name}
          />
        )}
      {!user && <NewToTapBanner />}
    </>
  );
};

export const Styles = {
  NavWrapper: {
    h: 20,
    px: { base: 5, md: 8 },
    direction: 'row',
    bg: 'white',
    boxShadow: 'md',
    zIndex: 3,
    position: 'relative',
    alignItems: 'center',
    fontFamily: `'Nunito Sans', sans-serif !important`,
    sx: {
      'h1, h2, h3, h4': {
        fontFamily: `'Nunito Sans', sans-serif !important`,
      },
    },
  },
  RightNav: {
    align: 'center',
  },
  NavButton: {
    py: 2,
    boxShadow: 'none',
    mr: 3,
    variant: 'ghost',
    color: 'gray.600',
    bg: 'none',

    _hover: {
      bg: TapTheme.fn.rgba(TapTheme.colors.blue[500], 0.13),
    },
    _active: {
      color: 'blue.500',
      bg: TapTheme.fn.rgba(TapTheme.colors.blue[500], 0.05),
    },
  },
  NavButtonProfile: {
    w: '50px',
    py: 2,
    fontSize: 'lg',
    fontWeight: 'extrabold',
    px: 0,
  },
};
